import React from "react";
import Layout from "./layout";

function Hrcompliance() {
  return (
    <Layout>
      <div className="flex justify-center items-center h-screen bg-gradient-to-br from-purple-500 to-blue-500">
        <p className="text-4xl font-bold text-white">Hr compliance</p>
      </div>
    </Layout>
  );
}

export default Hrcompliance;
